// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 132) return "static/chunks/dfe71ae1-4396287d82449d49.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1535":"a4416cb18af7b096","9945":"053f78044ca3024c"}[chunkId] + ".js";
};